export default __webpack_public_path__ + "static/media/3stepweightloss_3@2x.c93aadb3.jpg";